import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent } from '../common/button/components/button/button.component';
import { DividerComponent } from '../common/divider/divider.component';

@Component({
  selector: 'rt-thread-expander',
  templateUrl: './thread-expander.component.html',
  styleUrls: ['./thread-expander.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonComponent, DividerComponent],
})
export class ThreadExpanderComponent {
  public readonly text = input<string>(undefined!);
  public readonly withDivider = input<boolean>(true);

  public expand = output();
}
